module.exports = __webpack_public_path__ + "img/sherwynwilliams-img.5e19a9c1.jpg";